// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"835":"9a95d060","1045":"ad9a6584","1307":"ad9a6584","3699":"ad9a6584","4716":"24b45272","4881":"ad9a6584","6230":"1cd473cb","7088":"ad9a6584"}[chunkId] + ".chunk.css";
};